import api from './api';

const resource = 'KitchenTerminal/';

export const list = async (id) => {
  return await api.get(resource + `List?storeid=${id}`);
};

export const getById = async (id) => {
  return await api.get(resource + 'Get?id=' + id);
};

export const upsert = async (body) => {
  return await api.post(resource + 'Upsert', body);
};

export const deleteById = async (id) => {
  return await api.delete(resource + 'Delete?id=' + id);
};

const kitchenterminalApi = { list, getById, upsert, deleteById };

export default kitchenterminalApi;
